import { render, staticRenderFns } from "./ticketTaskCount.vue?vue&type=template&id=673b7607&scoped=true&"
import script from "./ticketTaskCount.vue?vue&type=script&lang=js&"
export * from "./ticketTaskCount.vue?vue&type=script&lang=js&"
import style0 from "./ticketTaskCount.vue?vue&type=style&index=0&id=673b7607&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b7607",
  null
  
)

export default component.exports